import { userConstant } from '../constants';
import { userService } from '../services';

export const userAction = {
    login,
    resetAPIMessages,
};

function login(userName, password) {
    return dispatch => {
        dispatch(request({ userName }));
        return userService.login(userName, password).then(
            (user) => {
                dispatch(success(user));
                return user;
            },
            (error) => {
                dispatch(failure(error));
                throw error;
            }
        );
    };

    function request(user) { return { type: userConstant.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstant.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstant.LOGIN_FAILURE, error } }
}

function resetAPIMessages() {
    return (dispatch) => {
        dispatch({ type: userConstant.RESET_API_MESSAGES });
    };
}
